import { IEnvironment } from 'interfaces/environments';

export const defaultEnvironment: IEnvironment = {
    name: '',
    type: '',
    createdAt: '',
    sortOrder: 0,
    enabled: false,
    protected: false,
};
